<template>
  <div class="dashboard" :class="{edit: editMode, add: addGadget}">
    <dashboard-setting-dialog ref="dashboardSettingDialog" @updated="changeShownGadget" />
    <div class="edit_dashboard" @click="trimEditMode"></div>
    <div class="add_gadget" @click="trimAddGadget"></div>
    <div class="paging">
      <ul>
        <el-button class="change_btn btn_left" @click="nextDates(-7)" icon="el-icon-caret-left"></el-button>
        <li v-for="date in dates" :class="{current: isTargetDate(date)}">
          <a href="#" @click="changeDate(date)">
            <span class="m">{{ date|printMonth }}</span>
            <span class="d">{{ date|printDay }}</span>
            <span class="w" :class="dateClass(date)">{{ printWeekday(date) }}</span>
          </a>
        </li>
        <el-button class="change_btn btn_right" @click="nextDates(7)" :disabled="isCurrentWeek" icon="el-icon-caret-right"></el-button>
      </ul>
    </div>
    <div>
      <icon-link-gadget v-show="hasCrmLicense"></icon-link-gadget>
      <grid-layout
        :col-num="12"
        :is-draggable="editMode"
        :is-resizable="false"
        :margin="[10, 10]"
        :autoSize="true"
        :vertical-compact="false"
        :row-height="20"
        :layout="layouts"
        v-loading="isLoading">
        <grid-item v-for="item in layouts"
          :key="item.i"
          @hide="hideGadget(gadget)"
          v-bind="item">
          <component
            v-bind:is="item.i"
            :targetDate="targetDate">
          </component>
        </grid-item>
      </grid-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {GridLayout, GridItem} from 'vue-grid-layout'

import DashboardSettingDialog from './DashboardSettingDialog'

import IconLinkGadget from './IconLink'
import SalesCountGadget from './SalesCount'
import PersonCountGadget from './PersonCount'
import SalesPersonCountGadget from './SalesPersonCount'
import CategorySalesPieChartGadget from './CategorySalesPieChart'
import CategoryCountPieChartGadget from './CategoryCountPieChart'
import TimeSalesBarChartGadget from './TimeSalesBarChart'
import TimePersonBarChartGadget from './TimePersonBarChart'
import ShopSalesDayGadget from './ShopSalesDay'
import {mapGetters, mapActions} from 'vuex'
import _ from 'lodash'

const defaultLayout = [{
  x: 0, y: 0, w: 4, h: 8, i: 'SalesCountGadget',
}, {
  x: 4, y: 0, w: 4, h: 8, i: 'PersonCountGadget',
}, {
  x: 8, y: 0, w: 4, h: 8, i: 'SalesPersonCountGadget',
}, {
  x: 0, y: 8, w: 6, h: 12, i: 'CategorySalesPieChartGadget',
}, {
  x: 6, y: 8, w: 6, h: 12, i: 'CategoryCountPieChartGadget',
}, {
  x: 0, y: 19, w: 6, h: 16, i: 'TimeSalesBarChartGadget',
}, {
  x: 6, y: 19, w: 6, h: 16, i: 'TimePersonBarChartGadget',
}]

const defaultGroupLayout = [...defaultLayout, {
  x: 0, y: 35, w: 6, h: 16, i: 'ShopSalesDayGadget',
}]

export default {
  name: 'Dashboard',
  components: {
    DashboardSettingDialog,
    GridLayout,
    GridItem,
    SalesCountGadget,
    PersonCountGadget,
    SalesPersonCountGadget,
    IconLinkGadget,
    CategorySalesPieChartGadget,
    CategoryCountPieChartGadget,
    TimeSalesBarChartGadget,
    TimePersonBarChartGadget,
    ShopSalesDayGadget,
  },
  data () {
    return {
      layouts: [],
      editMode: false,
      addGadget: false,
      isLoading: false,
      hideGadgets: [],
      groupGadgets: ['ShopSalesDayGadget'],
      targetDate: null,
      dates: [],
    }
  },
  computed: {
    ...mapGetters('holiday', ['holidays']),
    ...mapGetters('account', [
      'shopName',
      'hasGroup',
      'isGroupMode',
      'isAgencyUser',
      'hasCrmLicense',
      'hasSalesReportLicense',
      'hasReserveLicense',
    ]),
    isCurrentWeek () {
      return moment().isSameOrBefore(this.dates[6], 'day')
    },
  },
  watch: {
    isGroupMode (val) {
      if (val) {
        for (let gadget of this.groupGadgets) {
          this.addGroupGadget(gadget)
        }
      } else {
        for (let gadget of this.groupGadgets) {
          this.removeGroupGadget(gadget)
        }
      }
    },
  },
  filters: {
    printMonth (date) {
      return date.format('M')
    },
    printDay (date) {
      return date.format('D')
    },
  },
  methods: {
    ...mapActions('holiday', ['getHolidays']),
    trimEditMode () {
      this.editMode = !this.editMode
      if (!this.editMode) {
        this.addGadget = false
        // 現在のlayoutを保存
        this.$request.accounts.setDashboardSetting(this.layouts).then(res => {
        }, err => {
          console.log(err)
        })
      }
    },
    trimAddGadget () {
      // this.addGadget = !this.addGadget
      let selected = []
      this.layouts.forEach(x => {
        selected.push(x.i)
      })
      this.$refs.dashboardSettingDialog.show(selected)
    },
    isTargetDate (date) {
      if (this.targetDate && date.isSame(this.targetDate, 'day')) {
        return true
      }
      return false
    },
    dateClass (date) {
      let ret = []
      if (this.isHoliday(date)) {
        ret.push('hol')
      } else if (date.weekday() === 0) {
        ret.push('sun')
      } else if (date.weekday() === 6) {
        ret.push('sat')
      }
      return ret
    },
    changeDate (date) {
      this.targetDate = _.cloneDeep(date)
    },
    hideGadget (gadget) {
      console.log('hide')
    },
    dragstart (item, e) {
      console.log('dragstart', item)
      e.target.style.opacity = 0.5
    },
    dragend (e) {
      console.log('dragend', e)
      e.target.style.opacity = 1
    },
    dragenter (item) {
      console.log('dragenter', item)
    },
    printWeekday (date) {
      if (this.isHoliday(date)) {
        return '祝'
      }
      return moment(date).locale('ja').format('ddd')
    },
    isHoliday (date, before = false) {
      const k = before ? moment(date).add(1, 'days').format('YYYY-MM-DD') : moment(date).format('YYYY-MM-DD')
      if (this.holidays[k]) {
        return true
      }
      return false
    },
    addGroupGadget () {
      for (let gadget of this.groupGadgets) {
        let index = this.layouts.map(x => x.i).indexOf(gadget)
        if (index >= 0) {
          continue
        }
        let groupGadget = {x: 0, y: 0, w: 6, h: 16, i: gadget}
        let lastGridItem = this.layouts[this.layouts.length - 1]
        if (lastGridItem) {
          groupGadget.y = lastGridItem.y + lastGridItem.h
        }
        this.layouts.push(groupGadget)
      }
    },
    removeGroupGadget () {
      for (let gadget of this.groupGadgets) {
        let index = this.layouts.map(x => x.i).indexOf(gadget)
        if (index >= 0) {
          this.layouts.splice(index, 1)
        }
      }
    },
    fetchDashboardSetting () {
      this.isLoading = true
      this.$request.accounts.dashboardSetting().then(res => {
        if (!res.body.dashboardSetting) {
          // 設定がないのでデフォルト表示
          if (this.isGroupMode) {
            this.layouts = [...defaultGroupLayout]
          } else {
            this.layouts = [...defaultLayout]
          }
        } else {
          try {
            this.layouts = JSON.parse(res.body.dashboardSetting)
          } catch (e) {
            // jsonの形式がおかしいのでデフォルトをセット
            if (this.isGroupMode) {
              this.layouts = [...defaultGroupLayout]
            } else {
              this.layouts = [...defaultLayout]
            }
          }
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    changeShownGadget (selected) {
      console.log('aoiejfoiajeofjae:', selected)
      let choices
      if (this.isGroupMode) {
        choices = [...defaultGroupLayout]
      } else {
        choices = [...defaultLayout]
      }
      let layouts = []
      selected.forEach(k => {
        const tmp = choices.find(x => x.i === k)
        if (tmp) {
          layouts.push(tmp)
        } else {
          // MEMO: 通らないはず．確認
          console.log('err')
        }
      })
      this.layouts = layouts
    },
    nextDates (numberOfDate) {
      this.dates = this.dates.map(v => v.add(numberOfDate, 'days'))
    },
  },
  mounted () {
    this.fetchDashboardSetting()
    this.getHolidays()
    for (let i = 0; i < 7; i++) {
      this.dates.push(moment().startOf('date').add(moment.duration(i - 6, 'd')))
    }
    this.targetDate = moment().startOf('date').subtract(moment.duration(1, 'd'))
  },
  created () {
    this.targetDate = moment().startOf('date').subtract(moment.duration(1, 'd'))
  },
}
</script>

<style scoped>
.add_gadget,
.edit_dashboard {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 30px;
  right: 20px;
  box-sizing: border-box;
  border: 1px solid #D3D6D9;
  border-radius: 6px;
  background: url('/static/img/icon/edit.png') transparent no-repeat center center;
  background-size: 25px 25px;
  cursor: pointer;
  transition-property: right;
  transition-duration: .2s;
  z-index: 1;
}
.add_gadget {
  display: none;
  right: 70px;
  background-image: url('/static/img/icon/plus.png');
}
.add .add_gadget,
.edit .edit_dashboard {
  background-color: #E6ECEF;
  border: 1px solid rgba(255,255,255,0.7);
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.2);
}
.add .edit_dashboard {
  right: calc(260px);
}
.add .add_gadget {
  right: calc(310px);
}
.edit .add_gadget {
  display: block;
}
.paging {
  height: 100px;
  position: relative;
}
.paging ul {
  padding: 8px 10px 6px;
  position: absolute;
  width: 100%;
  bottom: 0;
}
.paging ul li {
  display: inline-block;
  width: 10%;
  max-width: 48px;
  height: 48px;
  margin-right: 6px;
  border-radius: 3px;
  vertical-align: bottom;
  background-color: #FFF;
  box-shadow: 0 1px 1px 1px rgba(0,0,0,0.1);
  color: #567;
}
.paging ul li.current {
  max-width: 60px;
  height: 60px;
  margin-top: 0;
  background-color: #FFF;
  border: 2px solid #4C7F9A;
  border-radius: 6px;
  box-shadow: none;
}
.paging ul li a {
  position: relative;
  display: block;
  height: 100%;
  text-decoration: none;
  color: inherit;
}
.paging ul li .m {
  position: absolute;
  top: 0;
  left: 1px;
  font-size: 12px;
  opacity: 0.8;
}
.paging ul li .d {
  display: block;
  font-size: 20px;
  text-align: center;
  line-height: 46px;
}
.paging ul li.current .d {
  font-size: 30px;
  line-height: 58px;
}
.paging ul li .w {
  position: absolute;
  display: block;
  width: 100%;
  height: 13px;
  bottom: 0;
  left: 0;
  background-color: #4C7F9A;
  border-radius: 0 0 3px 3px;
  line-height: 13px;
  font-size: 0.7em;
  text-align: center;
  color: #FFF;
  vertical-align: 2px;
}
.paging ul li .w.bho,
.paging ul li .w.sat {
  background-color: #3CD;
}
.paging ul li .w.hol,
.paging ul li .w.sun {
  background-color: #E34;
}

.bloc {
  position: relative;
  width: 100%;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  -webkit-align-items: center;
}
.bloc.hover {
  box-sizing: border-box;
  border: 2px dotted #4C7F9A;
  border-radius: 4px;
}
.edit .gadget .count,
.edit .gadget .chart {
  box-shadow: 0 0 4px rgba(0,0,0,0.3);
}
.edit .gadget:nth-of-type(odd) {
  -webkit-animation: vibe .3s .1s ease-in-out infinite;
  animation: vibe .3s .1s ease-in-out infinite;
}
.edit .gadget:nth-of-type(even) {
  -webkit-animation: vibe .3s .2s ease-in-out infinite;
  animation: vibe .3s .2s ease-in-out infinite;
}
@-webkit-keyframes vibe {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(0.2deg);
  }
  100% {
    transform: rotate(-0.2deg);
  }
}
.bloc > .dummy {
  width: 0;
  height: auto;
  min-height: 100px;
  margin: 0 auto;
  transition-property: all;
  transition-duration: .1s;
}
.bloc.hover > .dummy.hover {
  width: 100%;
}
.bloc.hover > .gadget.on + .dummy.hover {
  width: 0 !important;
}
.chart {
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  background-color: #FFF;
  box-shadow: 1px 1px 1px rgba(0,0,0,0.1);
}
.chart h3 {
  font-size: 14px;
  font-weight: normal;
}
.chart.bar h3,
.chart.scatter h3 {
  padding-bottom: 8px;
}
.chart_wrap {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.chart_wrap canvas {
  float: left;
}
.chart_wrap .legend {
  width: 30%;
  height: auto;
  overflow: hidden;
  float: left;
  z-index: 1;
}
.chart_wrap .legend li {
  width: 100%;
  height: 20px;
}
.chart_wrap .legend li > span {
  display: inline-block;
}
.chart_wrap .legend li .col {
  width: 10px;
  height: 10px;
  margin-right: 4px;
}
.chart_wrap .legend li .txt {
  font-size: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 1;
}
.chart canvas {
  width: 100%;
  max-width: 100%;
  height: auto;
}
.chart.pie canvas {
  width: 70%;
  max-width: 70%;
}
.hidden {
  position: fixed;
  width: 240px;
  height: 100%;
  top: 0;
  right: -240px;
  overflow: visible;
  box-sizing: border-box;
  padding: 118px 10px 0;
  background-color: #EEEFF0;
  transition-property: right;
  transition-duration: .2s;
  z-index: 10;
}

.dashboard.add {
  padding-right: calc(250px);
}
.add .edit_dashboard {
  right: calc(260px);
}
.add .add_gadget {
  right: calc(310px);
}
.edit .add_gadget {
  display: block;
}
.dashboard.add .hidden {
  box-shadow: -1px 0 0 0 #DDD;
  right: 0;
}
.change_btn {
  padding: 0px;
  vertical-align: bottom;
  color: #D0CECE;
  font-size: 45px;
  border: none;
  background: none;
}
.change_btn:hover {
  color: #4C7F9A;
  border: none;
  background: none;
}
.change_btn:focus {
  color: #4C7F9A;
  border: none;
  background: none;
}
.change_btn:disabled {
  color: #D0CECE;
  border: none;
  background: none;
}
.change_btn:disabled:hover {
  border: none;
  background: none;
}
.btn_left {
  margin-right: -12px;
}
.btn_right {
  margin-left: -20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Index.vue